import { Stack } from "@mui/material";
import Image from "src/components/Image";

// ----------------------------------------------------------------------

export const RighIlustration = () => {
	return (
		<Stack
			alignItems={"center"}
			justifyContent={"center"}
			sx={{ backgroundColor: "text.primary", height: "100vh" }}
		>
			<Image src={"/ilustrations/innovation_amico.svg"} sx={{ height: 450 }} />
		</Stack>
	);
};

export default RighIlustration;
